///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportUser = Meevo.Plugins.Reports.IReportUser;


    export class ReportUsersCollection extends SmartMoverApiCollection<IReportUser> implements IApiCollection<IReportUser> {

        protected get smartMoverHiddenValue(): SmartMoverHiddenValue {
            return SmartMoverHiddenValue.EmptyArray;
        }

        protected get url() {
            return 'report/User';
        }

        constructor(connectedModel: ModelValueType[], items: IReportUser[] = [], options: ICollectionOptions<IReportUser> = {}) {
            super(connectedModel, items, options);

            this.updateCriteria({
                'showEmployeesOnly': false,
                'includeActive': true,
                'includeInactive': false,
                'includeDeleted': false,
                'showTerminated': false,
                'firstName': '',
                'lastName': '',
                'coFilterByLocationId': null,
                'coBusinessTypeId': null,
                'filter': ''
            });
        }
    }

}
